export default __webpack_public_path__ + "static/media/coin_50gm.d6e24d58.jpg";